import {  Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "context/auth/authSlice";
import { useMaterialUIController,  setOpenConfigurator } from "context";
import { Grid, Card, Icon } from "@mui/material";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDBadge from "dashboard/components/MDBadge";

import DashboardLayout from "dashboard/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "dashboard/examples/Navbars/DashboardNavbar";
import Footer from "dashboard/examples/Footer";
import DataTable from "dashboard/examples/Tables/DataTable";
import MDAvatar from "dashboard/components/MDAvatar";
import loader from "assets/images/shapes/loader.svg";
// Data
import productsTableData from "components/sections/product/data/productsTableData";
import MDButton from "dashboard/components/MDButton";

export default function ProductTable()  {
  const connectedUser = useSelector(selectCurrentUser);
  const [controller, dispatch] = useMaterialUIController();
  const { openConfigurator } = controller;
  const configuratorOpen = (type, width) => { 
    setOpenConfigurator(dispatch,{ config : !openConfigurator, edit : type, width });
  }
  const { columns, rows, changePage, pageCount,totalResult, isLoading } = productsTableData({connectedUser});

  return (
    <DashboardLayout>
      <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  p={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography sx={{display: "flex", justifyContent:"space-between"}} variant="h4" color="white">
                    <span>Products <MDBadge badgeContent={totalResult} color="light" variant="gradient" size="sm" /></span>
                  </MDTypography>
                  {rows === 0 && <MDAvatar display="flex" sx={{padding: 0,position: "absolute",zIndex: 9,
                    top: "50%",left: "50%",transform: "translate3d(-24px, -40px, 0)"}}  
                    src={loader} alt="Avatar" variant="square" size="md" />}
                  </MDBox>
                
                  <MDBox pt={3} sx={{ minHeight:360 }}>
                    {rows && <DataTable
                      fetchData={changePage}
                      isloading={isLoading}
                      pageCount={pageCount}
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />}
                  </MDBox>
                  
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
    </DashboardLayout>
  );
}

